import { render, staticRenderFns } from "./assetsDetailReport.vue?vue&type=template&id=f923ef22&scoped=true"
import script from "./assetsDetailReport.vue?vue&type=script&lang=js"
export * from "./assetsDetailReport.vue?vue&type=script&lang=js"
import style0 from "./assetsDetailReport.vue?vue&type=style&index=0&id=f923ef22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f923ef22",
  null
  
)

export default component.exports